import React from 'react';
import ReactDOM from 'react-dom';
import { nanoid } from 'nanoid';
import { Plugin, PluginKey } from 'prosemirror-state';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { removeMenuContainer } from '../../utils';
import { LinkMarkMenu } from './LinkMarkMenu';

export const linkMarkMenuKey = new PluginKey('link-mark-menu-plugin');

const LINK_MARK_MENU_CONTAINER_ID = 'link-mark-menu-container';

export default class LinkMarkMenubar extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'linkmark_menu';
  }

  plugins({ portalApi }: EditorOptions) {
    return [
      new Plugin({
        key: linkMarkMenuKey,
        state: {
          init() {
            return { open: false };
          },
          apply(tr, old) {
            const props = tr.getMeta(linkMarkMenuKey);
            if (props) return props;
            return old;
          },
        },
        view: (editorView) => {
          // This will be called only once. It will add a container div.
          // LinkMark Menu will be rendered in this container div.
          let linkMarkMenuContainer = document.createElement('div');
          linkMarkMenuContainer.id = LINK_MARK_MENU_CONTAINER_ID;
          editorView?.dom?.parentNode?.appendChild(linkMarkMenuContainer);
          const portalKey = nanoid();

          // Need to return the following functions in the view function
          return {
            update: (view) => {
              let props = linkMarkMenuKey.getState(view.state);
              const dom = view?.dom?.parentNode?.querySelector(`#${LINK_MARK_MENU_CONTAINER_ID}`);
              if (dom) {
                portalApi.createPortal(
                  ReactDOM.createPortal(
                    <LinkMarkMenu editorView={view} link={props.link} open={props.open} />,
                    dom,
                    portalKey,
                  ),
                );
              }
            },
            destroy: () => {
              portalApi.destroyPortal(portalKey);
              removeMenuContainer(LINK_MARK_MENU_CONTAINER_ID, editorView);
            },
          };
        },
      }),
    ];
  }
}
